import { Component, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faPlusCircle,
	faFileExcel,
	faRotateRight,
} from '@fortawesome/free-solid-svg-icons'

import SelectPortal from '@/components/edit/SelectPortal/index.vue'

import Loader from '@/components/Loader/index.vue'
import fetch from '@/helpers/fetch'
// import Control from '@/helpers/control'

library.add(faPlusCircle, faFileExcel, faRotateRight)

@Component({
	components: {
		Loader,
		SelectPortal,
	},
})
export default class Collection extends Vue {
	currentPage = 1
	perPage = 10
	page = [10, 20, 30, 40, 50]
	pageInput = ''

	loading = false
	filtering = false
	downloading = false
	csvHref = ''
	downloadProp = 'acervo.csv'

	selectedClientId = null
	selectedTrial = null
	selectedGroupId = null
	selectedTypeId = null
	selectedProcedure = null
	selectedSystemId = null
	selectedCourt = null
	selectedSubject = [] as any[]
	selectedStatus = null
	selectedClientPosition = null
	selectedClosedString = 'Não'
	selectedClosedBoolean = false
	selectedElaborator = null
	selectedReviewer = null
	selectedAdvocate = null
	selectedCity = null
	selectedState = null
	selectedDistributionDate = null
	selectedDistributionEndDate = null
	selectedLocatelliEndDate = null
	selectedLocatelliStartDate = null

	clients = [] as any[]
	trials = [] as any[]
	groups = [] as any[]
	types = [] as any[]
	procedures = [] as any[]
	systems = [] as any[]
	courts = [] as any[]
	subjects = [] as any[]
	status = [] as any[]
	clientPosition = [] as any[]
	closed = [] as any[]
	elaborators = [] as any[]
	reviewers = [] as any[]
	advocates = [] as any[]
	citys = [] as any[]
	states = [] as any[]

	allCollection = [] as any[]
	showCollection = [] as any[]
	showFields = [] as any[]

	fields = [
		{
			key: 'index',
			label: '#',
			thStyle: 'min-width: 10px',
		},
		{
			key: 'group',
			label: 'Cliente',
			thStyle: 'min-width: 125px',
			defaultValue: true,
			formatter(groups) {
				if (!groups) return ''

				const result = groups.map((group) => {
					return group?.group?.name
				})

				return result.join(', ')
			},
		},
		{
			key: 'clients',
			label: 'Empresa',
			thStyle: 'min-width: 125px',
			defaultValue: true,
			formatter(clients) {
				if (!clients) return ''

				const result = clients.map((client) => {
					return client?.client?.name
				})

				return result.join(', ')
			},
		},
		{
			key: 'cnj',
			label: 'Processo',
			thStyle: 'min-width: 150px',
			defaultValue: true,
			formatter(cnj) {
				if (!cnj) return ''
				return cnj.replace(
					/(\d{7})(\d{2})(\d{4})(\d{1})(\d{2})(\d{4})/,
					'$1-$2.$3.$4.$5.$6',
				)
			},
		},
		{
			key: 'distributionDate',
			label: 'Data de distribuição',
			thStyle: 'min-width: 50px',
			defaultValue: true,
			formatter(date) {
				if (!date) return ''
				// YYYY-MM-DD para DD/MM/YYYY
				return date.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1')
			},
		},
		{
			key: 'locatelliStartDate',
			label: 'Data inicial Locatelli',
			thStyle: 'min-width: 50px',
			defaultValue: true,
			formatter(date) {
				if (!date) return ''
				return date.split('-').reverse().join('/')
			},
		},
		{
			key: 'locatelliEndDate',
			label: 'Data de arquivamento Locatelli',
			thStyle: 'min-width: 50px',
			defaultValue: true,
			formatter(date) {
				if (!date) return ''
				return date.split('-').reverse().join('/')
			},
		},
		{
			key: 'distributionEndDate',
			label: 'Data de arquivamento definitivo',
			thStyle: 'min-width: 50px',
			defaultValue: true,
			formatter(date) {
				if (!date) return ''
				return date.split('-').reverse().join('/')
			},
		},
		{
			key: 'lawsuitType',
			label: 'Tipo',
			thStyle: 'min-width: 150px',
			defaultValue: true,
			formatter(type) {
				return !type ? '' : type?.name
			},
		},
		{
			key: 'procedure',
			label: 'Trâmite',
			thStyle: 'min-width: 50px',
			defaultValue: true,
		},
		{
			key: 'system',
			label: 'Sistema',
			thStyle: 'min-width: 50px',
			defaultValue: true,
			formatter(system) {
				return !system ? '' : system?.name
			},
		},
		{
			key: 'city',
			label: 'Cidade',
			thStyle: 'min-width: 150px',
			defaultValue: false,
		},
		{
			key: 'state',
			label: 'Estado',
			thStyle: 'min-width: 50px',
			defaultValue: false,
		},
		{
			key: 'originCourt',
			label: 'Tribunal',
			thStyle: 'min-width: 50px',
			defaultValue: true,
		},
		{
			key: 'subjects',
			label: 'Assunto',
			thStyle: 'min-width: 150px',
			defaultValue: true,
			formatter(subjects) {
				if (!subjects) return ''

				const result = subjects.map((subject, index) => {
					return `${subject?.subject?.name || ''} (${index + 1})`
				})

				return result.join(', ')
			},
		},
		{
			key: 'loosingChance',
			label: 'Probabilidade de perda',
			thStyle: 'min-width: 150px',
			defaultValue: false,
			formatter(loosingChance) {
				if (!loosingChance || loosingChance.length === 0) return ''

				const result = loosingChance.map((item, index) => {
					return `${item?.loosingChance || ''} (${index + 1})`
				})

				return result.join(', ')
			},
		},
		{
			key: 'status',
			label: 'Status',
			thStyle: 'min-width: 50px',
			defaultValue: true,
		},
		{
			key: 'clientPosition',
			label: 'Posição',
			thStyle: 'min-width: 50px',
			defaultValue: true,
		},
		{
			key: 'closed',
			label: 'Encerrado',
			thStyle: 'min-width: 50px',
			defaultValue: true,
			formatter(value) {
				return !value ? 'Não' : 'Sim'
			},
		},
		{
			key: 'elaborator',
			label: 'Elaborador',
			thStyle: 'min-width: 50px',
			defaultValue: true,
		},
		{
			key: 'reviewer',
			label: 'Revisor',
			thStyle: 'min-width: 50px',
			defaultValue: true,
		},
		{
			key: 'advocate',
			label: 'Advogado',
			thStyle: 'min-width: 150px',
			defaultValue: true,
		},
	]

	// control = new Control()
	// acervo: HTMLElement | null = null

	async mounted() {
		let columnVisibility = this.getLocalStorageItem()

		if (!Object.keys(columnVisibility).length) {
			const defaultFields = {}
			this.fields.forEach((field) => {
				defaultFields[field.key] = field.defaultValue
			})
			this.setLocalStorageItem(defaultFields)

			columnVisibility = this.getLocalStorageItem()
		}

		this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
			const columnVisibility = this.getLocalStorageItem()
			this.fields.forEach((field) => {
				const element: any = document.getElementById(field.key)
				const isLocalStorage = Object.keys(columnVisibility).length
				if (element) {
					element.checked = isLocalStorage
						? columnVisibility[field.key]
						: field.defaultValue
				}
			})
		})

		this.filterFields({})

		await this.entriesProvider()
	}

	async entriesProvider() {
		this.loading = true
		const res = await fetch.get('/api/collection')

		this.allCollection.push(...res.data)
		this.allCollection.sort((a, b) => {
			const groupNameA = a.group?.[0]?.group?.name ?? ''
			const groupNameB = b.group?.[0]?.group?.name ?? ''

			if (groupNameA > groupNameB) {
				return 1
			}
			if (groupNameA < groupNameB) {
				return -1
			}
			return 0
		})

		this.showCollection = this.allCollection.filter((trial) => {
			let filtered = false

			if (trial?.closed === false) {
				filtered = true
			}

			trial.subjects = trial.subjects.filter((s) => {
				const name = s?.subject?.name

				return name !== '[EM BRANCO]'
			})

			return filtered && trial.subjects.length > 0
		})

		this.loadOptions()
		this.loading = false
	}

	async downloadCsv() {
		this.downloading = true

		const res = await fetch.get('/api/collection')

		const csvContent = res.csv
		const encodedUri = encodeURI(csvContent)

		this.csvHref = 'data:text/csv;charset=utf-8,\uFEFF' + encodedUri

		const time = new Date().getTime() - 3 * 60 * 60 * 1000

		this.downloadProp =
			'acervo-' + new Date(time).toISOString().substring(0, 16) + '.csv'

		await Vue.nextTick()
		const link: any = this.$refs.csvLink

		if (link && link.click) {
			link.click()
			this.downloading = false
		}
	}

	filterFields(event) {
		let columnVisibility = this.getLocalStorageItem()

		const updatedVisibility = {}
		if (Object.keys(event).length) {
			updatedVisibility[event.target.id] = event.target.checked
		}

		const mergedVisibility = {
			...columnVisibility,
			...updatedVisibility,
			index: true,
		}
		this.setLocalStorageItem(mergedVisibility)

		columnVisibility = this.getLocalStorageItem()

		const fieldsFiltered = this.fields.filter((field) => {
			return columnVisibility[field.key]
		})

		this.showFields = fieldsFiltered
	}

	getLocalStorageItem() {
		return JSON.parse(localStorage.getItem('columnVisibility') || '{}')
	}

	setLocalStorageItem(value) {
		localStorage.setItem('columnVisibility', JSON.stringify(value))
	}

	// isScrollAtMax(event) {
	// 	const scrollPosition = event.target.scrollTop
	// 	const maxScroll =
	// 		Math.max(event.target.scrollHeight) - window.innerHeight

	// 	return scrollPosition >= maxScroll
	// }

	loadOptions() {
		const groups = {}
		const clients = {}
		const types = {}
		const procedure = {}
		const system = {}
		const court = {}
		const subjects = {}
		const status = {}
		const clientPosition = {}
		const closed: Record<string, string> = {}
		const elaborators = {}
		const reviewers = {}
		const advocates = {}
		const citys = {}
		const states = {}
		this.allCollection.forEach((trial) => {
			trial.group.forEach((group) => {
				groups[group.group.name] =
					groups[group.group.name] || group.group
			})

			trial.clients.forEach((client) => {
				clients[client.client.name] =
					clients[client.client.name] || client.client
			})

			if (trial?.lawsuitType?.id) {
				types[trial?.lawsuitType?.id] = trial.lawsuitType
			}

			if (trial?.procedure) {
				procedure[trial?.procedure] = trial.procedure
			}

			if (trial?.system?.id) {
				system[trial?.system?.id] = trial.system
			}

			if (trial?.originCourt) {
				court[trial?.originCourt] = trial.originCourt
			}

			if (trial && trial.subjects) {
				trial.subjects.forEach((subject) => {
					if (subject && subject.subject && subject.subject.name) {
						subjects[subject.subject.name] =
							subjects[subject.subject.name] || subject.subject
					}
				})
			}

			if (trial?.status) {
				status[trial?.status] = trial.status
			}

			if (trial?.clientPosition) {
				clientPosition[trial?.clientPosition] = trial.clientPosition
			}

			if (trial?.closed !== null && trial?.closed !== undefined) {
				if (trial.closed) {
					closed[trial.closed] = 'Sim'
				} else {
					closed[trial.closed] = 'Não'
				}
				closed.Ambos = 'Ambos'
			}

			trial.group.forEach((group) => {
				const elaborator = group?.group?.elaborator?.email
				if (elaborator !== null && elaborator !== undefined) {
					elaborators[elaborator] = elaborator
				}
			})

			trial.group.forEach((group) => {
				const reviewer = group?.group?.reviewer?.email
				if (reviewer !== null && reviewer !== undefined) {
					reviewers[reviewer] = reviewer
				}
			})

			trial.group.forEach((group) => {
				const advocate = group?.group?.advocate?.email
				if (advocate !== null && advocate !== undefined) {
					advocates[advocate] = advocate
				}
			})

			if (trial?.city) {
				citys[trial?.city] = trial.city
			}

			if (trial?.state) {
				states[trial?.state] = trial.state
			}
		})
		this.groups = Object.keys(groups).map((key) => {
			return groups[key]
		})
		this.groups.sort(this.sortOptions)

		this.clients = Object.keys(clients).map((key) => {
			return clients[key]
		})
		this.clients.sort(this.sortOptions)
		this.types = Object.keys(types).map((key) => {
			return types[key]
		})
		this.procedures = Object.keys(procedure).map((key) => {
			return procedure[key]
		})
		this.systems = Object.keys(system).map((key) => {
			return system[key]
		})
		this.courts = Object.keys(court).map((key) => {
			return court[key]
		})
		this.subjects = Object.keys(subjects).map((key) => {
			return subjects[key]
		})
		this.status = Object.keys(status).map((key) => {
			return status[key]
		})
		this.clientPosition = Object.keys(clientPosition).map((key) => {
			return clientPosition[key]
		})

		this.closed = Object.keys(closed).map((key) => {
			return closed[key]
		})

		this.elaborators = Object.keys(elaborators).map((key) => {
			return elaborators[key]
		})

		this.reviewers = Object.keys(reviewers).map((key) => {
			return reviewers[key]
		})
		this.advocates = Object.keys(advocates).map((key) => {
			return advocates[key]
		})
		this.citys = Object.keys(citys).map((key) => {
			return citys[key]
		})
		this.states = Object.keys(states).map((key) => {
			return states[key]
		})
	}

	sortOptions(a, b) {
		if (a.name > b.name) {
			return 1
		}
		if (a.name < b.name) {
			return -1
		}
		return 0
	}

	entriesSearch() {
		this.filtering = true
		setTimeout(() => {
			if (
				this.selectedGroupId ||
				this.selectedClientId ||
				this.selectedTrial ||
				this.selectedTypeId ||
				this.selectedProcedure ||
				this.selectedSystemId ||
				this.selectedCourt ||
				this.selectedSubject ||
				this.selectedStatus ||
				this.selectedClientPosition ||
				this.selectedClosedString ||
				this.selectedElaborator ||
				this.selectedReviewer ||
				this.selectedAdvocate ||
				this.selectedCity ||
				this.selectedState ||
				this.selectedDistributionDate ||
				this.selectedDistributionEndDate ||
				this.selectedLocatelliEndDate ||
				this.selectedLocatelliStartDate
			) {
				this.showCollection = this.allCollection.filter((trial) => {
					let filtered = true // Inicialmente, todos os trials são considerados filtrados

					if (this.selectedClientId) {
						const foundClient = trial.clients.find(
							(client) =>
								client.client.id === this.selectedClientId,
						)
						if (!foundClient) {
							filtered = false
						}
					}

					if (this.selectedGroupId) {
						if (
							!trial?.group[0]?.group ||
							trial?.group[0]?.group.id !== this.selectedGroupId
						) {
							filtered = false
						}
					}

					if (
						this.selectedTrial &&
						trial.cnj !== this.selectedTrial
					) {
						filtered = false
					}

					if (
						this.selectedTypeId &&
						(!trial.lawsuitType ||
							trial.lawsuitType.id !== this.selectedTypeId)
					) {
						filtered = false
					}

					if (
						this.selectedProcedure &&
						trial.procedure !== this.selectedProcedure
					) {
						filtered = false
					}

					if (
						this.selectedSystemId &&
						(!trial.system ||
							trial.system.id !== this.selectedSystemId)
					) {
						filtered = false
					}

					if (
						this.selectedCourt &&
						trial.originCourt !== this.selectedCourt
					) {
						filtered = false
					}

					if (
						this.selectedSubject !== null &&
						this.selectedSubject !== undefined &&
						this.selectedSubject.length !== 0
					) {
						const foundSubject = trial.subjects.find(
							(subject) =>
								subject.subject !== null &&
								subject.subject !== undefined &&
								this.selectedSubject?.includes(
									subject.subject.name,
								),
						)
						if (!foundSubject) {
							filtered = false
						}
					}

					if (
						this.selectedStatus &&
						trial.status !== this.selectedStatus
					) {
						filtered = false
					}

					if (
						this.selectedClientPosition &&
						trial.clientPosition !== this.selectedClientPosition
					) {
						filtered = false
					}

					if (this.selectedClosedString) {
						if (this.selectedClosedString === 'Sim') {
							this.selectedClosedBoolean = true
						} else if (this.selectedClosedString === 'Não') {
							this.selectedClosedBoolean = false
						} else if (this.selectedClosedString === 'Ambos') {
							// Se a opção "Todos" estiver selecionada, não aplicamos filtro por closed
							return filtered
						}

						if (trial.closed !== this.selectedClosedBoolean) {
							filtered = false
						}
					}

					if (this.selectedElaborator) {
						const foundElaborator = trial.group.find(
							(group) =>
								group?.group?.elaborator?.email ===
								this.selectedElaborator,
						)
						if (!foundElaborator) {
							filtered = false
						}
					}

					if (this.selectedReviewer) {
						const foundReviewer = trial.group.find(
							(group) =>
								group?.group?.reviewer?.email ===
								this.selectedReviewer,
						)
						if (!foundReviewer) {
							filtered = false
						}
					}

					if (this.selectedAdvocate) {
						const foundAdvocate = trial.group.find(
							(group) =>
								group?.group?.advocate?.email ===
								this.selectedAdvocate,
						)
						if (!foundAdvocate) {
							filtered = false
						}
					}
					if (this.selectedCity && trial.city !== this.selectedCity) {
						filtered = false
					}

					if (
						this.selectedState &&
						trial.state !== this.selectedState
					) {
						filtered = false
					}

					if (
						this.selectedDistributionDate &&
						trial.distributionDate !== this.selectedDistributionDate
					) {
						filtered = false
					}

					if (
						this.selectedDistributionEndDate &&
						trial.distributionEndDate !==
							this.selectedDistributionEndDate
					) {
						filtered = false
					}

					if (
						this.selectedLocatelliEndDate &&
						trial.locatelliEndDate !== this.selectedLocatelliEndDate
					) {
						filtered = false
					}

					if (
						this.selectedLocatelliStartDate &&
						trial.locatelliStartDate !==
							this.selectedLocatelliStartDate
					) {
						filtered = false
					}

					return filtered
				})
			}

			this.filtering = false
			this.$bvModal.hide('inserir-pesquisa')
		}, 30)
	}

	reloadTable() {
		this.showCollection = []

		this.showCollection = this.allCollection.filter((trial) => {
			let filtered = false

			if (trial?.closed === false) {
				filtered = true
			}

			return filtered
		})

		this.currentPage = 1
	}

	goToPage() {
		const pageNumber = parseInt(this.pageInput)
		if (!isNaN(pageNumber)) {
			this.currentPage = pageNumber
		}
		this.pageInput = ''
	}
}
